<template>
  <v-dialog persistent v-model="show" width="60%">
    <v-card style="padding:40px;">
      <v-card-title>
        <span class="headline">追加支払請求費用の修正</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="save">保存</v-btn>
        <v-btn @click="back">戻る</v-btn>
      </v-card-actions>
      <v-card-text>Do.No:{{ shipment.doNo }}</v-card-text>
      <br />
      <v-card-text>
        <span style="font-weight:bold">事業本部:</span>
        <v-text-field style="padding-top:0px;" v-model="shipment.displayBuName"></v-text-field>
      </v-card-text>
      <v-card-text>
        <span style="font-weight:bold">最終納入場所:</span>
        <v-text-field style="padding-top:0px;" v-model="shipment.displayWarehouseName"></v-text-field>
      </v-card-text>
      <v-card-text>追加支払請求費用/追加請求</v-card-text>
      <v-data-table
        :headers="headers"
        :items="additionalCharges"
        :rows-per-page-items="[10]"
        class="elevation-1 mt-2 mb-2 inline-edit"
      >
        <template slot="items" slot-scope="props">
          <td>{{props.item.chargeItemName}}</td>
          <td>{{props.item.subTotal}}</td>
          <td>{{ props.item.scopes === '1' ? props.item.supplierName : ''}}</td>
          <td>{{props.item.comment}}</td>
        </template>
      </v-data-table>
      <v-card-text>修正：</v-card-text>
      <v-data-table
        :headers="fixHeaders"
        :items="fixedCharges"
        :rows-per-page-items="[30]"
        class="elevation-1 mt-2 mb-2 inline-edit"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.chargeItemName }}</td>
          <td>
            <v-text-field type="number" v-model="props.item.subTotal"></v-text-field>
          </td>
          <!-- <td>{{ props.item.subTotal }}</td> -->
          <td>
            <remote-autocomplete
              :rules="props.item.subTotal?[v=> !!v || `支払先 is required`]:[]"
              clearable
              disabled="true"
              placeholder="请输入支払先"
              url="companies/supplier"
              v-if="props.item.scopes === '1'"
              v-model="props.item.supplierId"
            />
          </td>
          <td>
            <v-text-field v-model="props.item.comment"></v-text-field>
          </td>
          <td>
            <v-icon @click="add(props.item)">add</v-icon>
            <v-icon @click="remove(props.item)">remove</v-icon>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-card></v-card>
  </v-dialog>
</template>
<script>
import ChargeItemDialog from './ChargeItemDialog'
export default {
  components: { ChargeItemDialog },
  data() {
    return {
      show: false,
      fixHeaders: [
        { text: '費用項目', sortable: false },
        { text: '金額', sortable: false },
        { text: '支払先', sortable: false },
        { text: 'コメント', sortable: false },
        { text: 'Actions', sortable: false },
      ],
      headers: [
        { text: '費用項目', sortable: false },
        { text: '金額', sortable: false },
        { text: '支払先', sortable: false },
        { text: 'コメント', sortable: false },
      ],
      fixedCharges: [],
      shipment: {},
      additionalCharges: [],
    }
  },
  methods: {
    save() {
      this.$http
        .post(`/shipment-charge-detail/${this.shipment.id}`, this.fixedCharges)
        .then(() => {
          this.$http
            .put(`/delivery-orders/${this.shipment.id}/updateDisplayName`, {
              displayBuName: this.shipment.displayBuName,
              displayWarehouseName: this.shipment.displayWarehouseName,
            })
            .then(() => {
              this.$message('', 'SUCCESS')
              this.$emit('refresh')
              this.show = false
            })
        })
        .catch(() => {
          this.$message(
            '',
            '修正後の合計金額が修正前と一致しなければなりません。'
          )
        })
    },
    add(data) {
      this.fixedCharges.push({ ...data, id: null })
      this.fixedCharges = this.fixedCharges.sort(function (a, b) {
        return Number(a.seq) - Number(b.seq)
      })
    },
    remove(data) {
      const index = this.fixedCharges.indexOf(data)
      this.fixedCharges.splice(index, 1)
    },
    back() {
      this.show = false
      this.payRequestFee = []
      this.requestFee = []
    },
    popup(data) {
      this.show = true
      this.shipment = { ...data }
      var additionalCharges = this.shipment.eiajChargeVos
        .filter((c) => c.scopes === '1' || c.scopes === '4')
        .filter((c) => c.subTotal !== 0)
        .sort(function (a, b) {
          return Number(a.seq) - Number(b.seq)
        })

      this.additionalCharges = additionalCharges.map((i) => ({ ...i }))
      if (this.shipment.chargeDetails.length > 0) {
        this.fixedCharges = [...this.shipment.chargeDetails].sort(function (
          a,
          b
        ) {
          return Number(a.seq) - Number(b.seq)
        })
        return
      }

      this.fixedCharges = additionalCharges
        .filter((c) => c.subTotal !== 0)
        .map((i) => ({ ...i, id: null }))
    },
    close() {
      this.show = false
    },
  },
  watch: {},
  computed: {},
}
</script>
